import { ref, computed } from 'vue'
import { useAlert } from '@/libs/alertPortal'
import {
  useSettingsPageTeamManagementViewQuery,
  useCreateTeamMutation,
  useDeleteTeamMutation,
} from '../SettingsPageTeamManagementView.generated'

export const useTeamManagement = () => {
  const { result, loading, refetch } = useSettingsPageTeamManagementViewQuery({
    fetchPolicy: 'no-cache',
  })

  const alert = useAlert()
  const isSubmitting = ref(false)

  const teams = computed(() => result.value?.teams || [])
  const isLoading = computed(() => loading.value)

  const { mutate: createTeamMutation } = useCreateTeamMutation({
    fetchPolicy: 'no-cache',
  })

  const createTeam = async (teamName: string) => {
    if (!teamName) {
      return
    }

    const selfGUID = result.value?.viewer.staff.guid
    if (!selfGUID) {
      alert.error('メンバー情報が取得できませんでした')
      return
    }

    try {
      isSubmitting.value = true

      await createTeamMutation({
        input: {
          name: teamName,
          staffGUIDs: [selfGUID],
        },
      })

      alert.success('チームを作成しました')
    } catch (e) {
      alert.error('作成に失敗しました、もう一度お試しください')
      console.error(e)
    } finally {
      await refetch()
      isSubmitting.value = false
    }
  }

  const { mutate: deleteTeamMutation } = useDeleteTeamMutation({
    fetchPolicy: 'no-cache',
  })

  const deleteTeam = async (teamGUID: string) => {
    if (!window.confirm('このチームを削除しますか？')) {
      return
    }

    try {
      isSubmitting.value = true

      await deleteTeamMutation({
        input: {
          guid: teamGUID,
        },
      })

      alert.success('チームを削除しました')
    } catch (e) {
      alert.error('削除に失敗しました、もう一度お試しください')
      console.error(e)
    } finally {
      await refetch()
      isSubmitting.value = false
    }
  }

  return {
    teams,
    isLoading,
    isSubmitting,
    createTeam,
    deleteTeam,
  }
}
